import { useParallax } from 'components/parallax/useParallax'
import HandSrc from '../animation/images/Hand1_L.webp'
import { HandContainer, HandImg } from './styled'

export const ParallaxHand = () => {
  const { ref, translateY, isMobile } = useParallax({
    fromTo: ['30vh', '-30vh'],
  })

  return (
    <HandContainer
      ref={ref}
      style={{
        translateY,
        translateX: isMobile ? 0 : 'calc(-100vw + 100%)',
      }}
    >
      <HandImg src={HandSrc} alt="" aria-hidden />
    </HandContainer>
  )
}
